import Swiper from 'swiper';
import { Navigation, Mousewheel, FreeMode } from 'swiper/modules';

export function alphabetFilter() {
    let swiperInstances = {};

    // const url = new URL(window.location.href);
    // const language = url.searchParams.get('language');

    const swiperOptions = {
        slidesPerView: 'auto',
        modules: [Navigation, Mousewheel, FreeMode],
        spaceBetween: 0,
        slideClass: 'alphabet-filter__link',
        wrapperClass: 'alphabet-filter',
        preventClicks: true,
        preventClicksPropagation: true,
        navigation: {
            nextEl: '.swiper-nav--next',
            prevEl: '.swiper-nav--prev',
        },
        slidesOffsetBefore: 32,
        slidesOffsetAfter: 32,
        forceToAxis: true,
        mousewheel: {
        },
        freeMode: {
            enabled: true,
            sticky: true,
        },
    };

    // Since we use facetwp loadMore pager, we need to make sure that the alphabet filter is updated
    document.addEventListener('facetwp-loaded', function() {
        // Destroy the swipers before creating new ones
        if(swiperInstances.alphabetSwiperTop) {
            swiperInstances.alphabetSwiperTop.destroy();
        }
        if(swiperInstances.alphabetSwiperBottom) {
            swiperInstances.alphabetSwiperBottom.destroy();
        }

        const container = document.querySelectorAll('.alphabet-swiper-top .alphabet-filter__link');
        const selectedEl = document.querySelector('.alphabet-swiper-top .alphabet-filter__link.selected');
        swiperOptions.initialSlide = [...container].indexOf(selectedEl);
        
        // Make the facet scrollable via swiper
        swiperInstances.alphabetSwiperTop = new Swiper('.alphabet-swiper-top', swiperOptions);
        swiperInstances.alphabetSwiperBottom = new Swiper('.alphabet-swiper-bottom', swiperOptions);

        //Sync bottom facet  scroll to top facet
        swiperInstances.alphabetSwiperTop.on('progress', function(swiper, progress) {
            swiperInstances.alphabetSwiperBottom.setProgress(progress);
        });
        
        // Set visibility on bottom facet based on post count
        const postsContainer = document.querySelector('.facetwp-template');
        const numberOfArticles = postsContainer.querySelectorAll('article').length;

        if(numberOfArticles < 4) {
            swiperInstances.alphabetSwiperBottom.hostEl.classList.remove(...['md:block']);
            swiperInstances.alphabetSwiperBottom.hostEl.classList.add(...['hidden']);
        } else if(numberOfArticles < 7) {
            swiperInstances.alphabetSwiperBottom.hostEl.classList.remove(...['md:block', 'hidden']);
            swiperInstances.alphabetSwiperBottom.hostEl.classList.add(...['sm:hidden', 'lg:hidden']);
        } else if(numberOfArticles < 10) {
            swiperInstances.alphabetSwiperBottom.hostEl.classList.add(...['sm:hidden', 'md:block', 'hidden']);
        } else {
            swiperInstances.alphabetSwiperBottom.hostEl.classList.remove(...['sm:hidden', 'md:block', 'lg:hidden', 'hidden']);
        }
    });
}

export function countPostsByCharacter() {
    const theContainer = document.querySelector('.facetwp-template');
    const countInput = theContainer.querySelectorAll('.char-count');
    
    countInput.forEach((count) => {
        const numberOfArticles = theContainer.querySelectorAll('[data-starting-character="' + count.dataset.currentChar + '"]').length;
        count.innerHTML = numberOfArticles;
    });
}